/**
 * Linear - no easing, no acceleration.
 * 
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function linear( t: number ): number
{
	return t;
}

/* ==================================================
 * Quadratic Ease
 */

/**
 * Quadratic Ease in - accelerating from zero velocity.
 * 
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function quadIn( t: number ): number
{
	return t * t;
}

/**
 * Quadratic Ease out - decelerating to zero velocity.
 * 
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function quadOut( t: number ): number
{
	return t * (2 - t);
}

/**
 * Quadratic Ease in-out - acceleration until halfway,
 * then deceleration.
 * 
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function quadInOut( t: number ): number
{
	return ( t < 0.5 )
		? t * t * 2
		: t * (4 - t * 2) - 1;
}

/* ==================================================
 * Cubic Ease
 */

/**
 * Cubic Ease in - accelerating from zero velocity.
 * 
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function cubicIn( t: number ): number
{
	return t * t * t;
}

/**
 * Cubic Ease out - decelerating to zero velocity.
 * 
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function cubicOut( t: number ): number
{
	return (--t) * t * t + 1;
}

/**
 * Cubic Ease in-out - acceleration until halfway,
 * then deceleration.
 * 
 * @param {number} t Time from 0 to 1
 * @returns {number}
 */
function cubicInOut( t: number ): number
{
	return ( t < 0.5 )
		? t * t * t * 4
		: (t - 1) * (t * 2 - 2) * (t * 2 - 2) + 1;
}

/* ==================================================
 * Other
 */

type EasingFunction = ( time: number ) => number;

/**
 * Module
 */
export {
	EasingFunction,
	linear,
	quadIn,
	quadOut,
	quadInOut,
	cubicIn,
	cubicOut,
	cubicInOut,
};



// WEBPACK FOOTER //
// ./utils/animation/Ease.ts